export default __webpack_public_path__ + "static/media/Bmi.d35e3459.png";